import React from 'react';
import { COLORS } from '@bumble/app/theme';
import { Badge, Box, Breadcrumbs, Link, Typography } from '@mui/material';
import { Link as RouterLink } from 'react-router-dom';

type Breadcrumb = { label: string; to: string };
interface PageHeaderProps {
  pageName?: string;
  breadcrumbs?: Breadcrumb[];
  count?: number;
  description?: string;
  actions?: React.ReactNode;
}

function PageHeader({
  pageName = '',
  breadcrumbs,
  count = 0,
  description,
  actions,
}: React.PropsWithChildren<PageHeaderProps>) {
  const pageNameList = [
    'Internet CPE',
    'Metro Ethernet NIDs',
  ];

  const oobPageList = [
    'PDU Management',
    'USB Serial Console Access',
    'Network-Based Access',
  ];

  const cellularWANPageList = [
    'Cellular WAN'
  ]

  let rootLabel = 'Systems';
  let rootPath = '/dashboard';

  if (pageNameList.includes(pageName)) {
    rootLabel = 'Dashboards';
    rootPath = '/main-dashboard';
  }

  if (oobPageList.includes(pageName)) {
    rootLabel = 'OOB Remote Control';
    rootPath = '/oob-remote-control';
  }

  if (cellularWANPageList.includes(pageName)) {
    rootLabel = '';
    rootPath = '';
  }

  return (
    <Box sx={{ p: 1 }}>
      <Breadcrumbs aria-label="breadcrumb" sx={{ mb: 5 }}>
        {rootLabel && (
          pageNameList.includes(pageName) ? (
            <Link
              component={RouterLink}
              underline="hover"
              color="inherit"
              to={rootPath}
            >
              {rootLabel}
            </Link>
          ) : (
            <Typography color="inherit">{rootLabel}</Typography>
          )
        )}
        {breadcrumbs &&
          breadcrumbs.map(({ label, to }) => (
            <Link component={RouterLink} underline="hover" color="inherit" to={to} key={label}>
              {label}
            </Link>
          ))}
        <Typography color="primary">{pageName}</Typography>
      </Breadcrumbs>
      <Box sx={{ display: 'flex' }}>
        <Box>
          <Badge badgeContent={count} color="primary">
            <Typography variant="h3" component="h1" sx={{ color: COLORS.TEXT, pr: 2, mb: 3 }}>
              {pageName}
            </Typography>
          </Badge>
          {description && (
            <Typography variant="body1" sx={{ mb: 3, maxWidth: 860 }}>
              {description}
            </Typography>
          )}
        </Box>
        {actions && <Box sx={{ ml: 'auto' }}>{actions}</Box>}
      </Box>
    </Box>
  );
}

export default PageHeader;
